import {
  Button,
  Card,
  Col,
  Input,
  Pagination,
  Row,
  Spin,
  Table,
  Tag,
  Space,
  Popconfirm,
  App,
} from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowUpOutlined, BarChartOutlined, DeleteFilled, DownloadOutlined, EyeOutlined, FileExclamationOutlined, GlobalOutlined, LoadingOutlined, MailOutlined, PlusOutlined, TeamOutlined } from "@ant-design/icons";
import debounce from 'lodash.debounce';
import { CAMPAIGN_SUMMARY, DOWNLOAD_CAMPAIGN, LIST_CAMPAIGN, SOFT_DELETE } from "../../apis/apis";
import CulsightPageLoader from '../../components/CulsightPageLoader';
import { formatToIST } from "../../../helper/CommonHelper";

function Campaign() {
  const location = useLocation();
  const { message } = App.useApp();
  const { notification } = App.useApp();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [table_data, set_table_data] = useState([]);
  const [total_pages, set_total_pages] = useState("");
  const [total_campaigns, set_total_campaigns] = useState("");

  // CAMPAIGN SUMMARY STATES
  const [total_sent, set_total_sent] = useState("");
  const [total_users, set_total_users] = useState("");
  const [total_campaign, set_total_campaign] = useState("");
  const [active_campaign, set_active_campaign] = useState("");



  const [current_page, set_current_page] = useState(

    location.state?.page || 1

  );

  const [page_size, set_page_size] = useState(

    location.state?.pageSize || 10

  );

  const [search_query_name, set_search_query_name] = useState(

    location.state?.search || ""

  );



  // LIST API
  const LIST_API = async () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("per_page", page_size);
    FORM_DATA.append("page", current_page);
    FORM_DATA.append("name", search_query_name);

    const API_CALL = await LIST_CAMPAIGN(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
      set_total_campaigns(API_CALL?.data?.total_campaigns);
      setLoader(false);
    } else {
      console.log("error");
      setLoader(false);
    }
  };

  useEffect(() => {
    LIST_API();
  }, [page_size, current_page]);

  // SEARCH API
  const fetchResultsName = useCallback((value) => {
    debounce(async () => {
      try {
        set_search_query_name(value);
        set_pagination_loader(true);
        const FORM_DATA = new FormData();
        FORM_DATA.append("name", value);
        const API_CALL = await LIST_CAMPAIGN(FORM_DATA);
        if (API_CALL?.data?.status) {
          set_table_data(API_CALL.data?.data);
          set_current_page(API_CALL?.data?.current_page);
          set_total_pages(API_CALL?.data?.total_pages);
          set_total_campaigns(API_CALL.data?.total_campaigns);
        }
        set_pagination_loader(false);
      } catch (err) {
        console.error("API Error:", err);
      }
    }, 500)();
  }, []);

  const handleInput = (e) => {
    const value = e.target.value;
    fetchResultsName(value);
  };

  // DELETE HANDLER
  const handleDelete = async (id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("id", id);

    try {
      const response = await SOFT_DELETE(FORM_DATA);
      if (response?.data?.status) {
        message.success("Campaign deleted successfully");
        LIST_API(); // refresh list
      } else {
        message.error("Failed to delete campaign");
      }
    } catch (error) {

      message.error("Something went wrong");
    }
  };


  // Stop campaign
  // const stopcampaign = async (id) => {
  //   const FORM_DATA = new FormData();
  //   FORM_DATA.append("id", id);

  //   try {
  //     const response = await SOFT_DELETE(FORM_DATA);
  //     if (response?.data?.status) {
  //       message.success("Campaign deleted successfully");
  //       LIST_API(); // refresh list
  //     } else {
  //       message.error("Failed to stop campaign");
  //     }
  //   } catch (error) {

  //     message.error("Something went wrong");
  //   }
  // };

  // TABLE COLUMNS
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => <span>{record.name}</span>,
    },
    {
      title: "SMTP",
      dataIndex: "smtp_name",
      render: (text, record) => <span>{record.smtp_name}</span>,
    },
    {
      title: "User Group",
      dataIndex: "group_name",
      render: (text, record) => <span>{record.group_name} ({record.group_type === 1 ? "LMS Group" : "Local Group"})</span>,
    },
    {
      title: "Email Template",
      dataIndex: "email_template_name",
      render: (text, record) => <span>{record.email_template_name}</span>,
    },
    // {
    //   title: "User Count",
    //   dataIndex: "total_users",
    //   render: (text, record) => <span>{record.total_users}</span>,
    // },



    // {
    //   title: "Created On",
    //   dataIndex: "created_at",
    //   render: (text, record) => (
    //     <span>{formatToIST(record.created_at)}</span>
    //   ),
    // },
    {
      title: "Stats",
      dataIndex: "stats",
      render: (_, record) => (
        <Space size="small" style={{ flexWrap: "nowrap" }}>
          <span style={{ fontWeight: "600", color: "#8c3add", whiteSpace: "nowrap" }}>
            Sent: {record.email_send || 0}
          </span>

          <span style={{ fontWeight: "600", color: "#1fa7a1", whiteSpace: "nowrap" }}>
            Open: {record.email_open || 0}
          </span>

          <span style={{ fontWeight: "600", color: "orange", whiteSpace: "nowrap" }}>
            Click: {record.email_clicked || 0}
          </span>
        </Space>
      ),
    },

    // {
    //   title: "Status",
    //   dataIndex: "campaign_status",
    //   render: (campaign_status) =>
    //     campaign_status ? (
    //       <Tag color="green">Active</Tag>
    //     ) : (
    //       <Tag color="red">Inactive</Tag>
    //     ),
    // },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            onClick={() =>

              navigate("/view-campaign/" + btoa(record.id), {

                state: {
                  from: "campaign",
                  page: current_page,

                  pageSize: page_size,

                  search: search_query_name

                }

              })

            }


          >
            <BarChartOutlined />
          </Button>
          <Popconfirm
            title="Are you sure to delete this campaign?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button color='red' variant='solid'>
              <DeleteFilled />
            </Button>


          </Popconfirm>

          {/* <Popconfirm
            title="Are you sure to stop this campaign?"
            onConfirm={() => stopcampaign(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button color='red' variant='solid'>
              <DeleteFilled />
            </Button>


          </Popconfirm> */}
          <Button

            variant='solid'
            onClick={() => DOWNLOAD_CAMPAIGN_REPORT(record.id)}
            style={{ backgroundColor: "#1fa7a1", color: "#ffffff" }}
          >
            <DownloadOutlined />
          </Button>
        </Space>
      ),
    },
  ];

  // PAGINATION HANDLER
  const pagination_on_change = async (page, size) => {
    set_pagination_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("page", page);
    FORM_DATA.append("per_page", size);
    FORM_DATA.append("name", search_query_name);
    const API_CALL = await LIST_CAMPAIGN(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_table_data(API_CALL.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
      set_total_campaigns(API_CALL?.data?.total_campaigns);
    }
    set_pagination_loader(false);
  };


  const DOWNLOAD_CAMPAIGN_REPORT = async (id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("campaign_id", id);

    const API_CALL = await DOWNLOAD_CAMPAIGN(FORM_DATA);
    if (API_CALL?.data?.status) {
      notification.success({
        message: "Successful",
        description: "Check the Download tab for your report",
      });
    } else {
      console.log("error");
      setLoader(false);
    }
  };

  // LIST CAMPAIGN SUMMARY 

  const CAMPAIGN_SUMMARY_LIST = async () => {
    const FORM_DATA = new FormData();
    const API_CALL = await CAMPAIGN_SUMMARY(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_total_campaign(API_CALL?.data?.total_campaign);
      set_total_sent(API_CALL?.data?.total_sent);
      set_total_users(API_CALL?.data?.total_users);
      set_active_campaign(API_CALL?.data?.active_campaign);
      setLoader(false);
    } else {
      console.log("error");
      setLoader(false);
    }
  };

  useEffect(() => {
    CAMPAIGN_SUMMARY_LIST();
  }, []);


  return (

    <div className='lms-body'>
      <Row>
        <Col span={12}>
          <h1 style={{ margin: "0px", padding: "0px" }}>Campaigns</h1>
          <span style={{ color: "gray", fontSize: "15px", fontWeight: "600" }}>Manage your phishing simulation campaigns</span>
        </Col>
        <Col span={12}>
          <Button
            type='primary'
            size='large'
            onClick={() => navigate('/add-campaign')}
            style={{ float: "right" }}
          >
            <PlusOutlined />
            Add Campaign
          </Button>
        </Col>
      </Row>

      <Row gutter={[20, 20]} style={{ marginTop: "20px" }}>

        <Col xs={24} sm={12} md={12} lg={6}>
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
              display: "flex",
              alignItems: "center",
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}

          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#ede9fe",
                  padding: "10px",
                  borderRadius: "12px",
                  marginLeft: "-100px"

                }}
              >
                <GlobalOutlined style={{ color: "#8c3add", fontSize: 18 }} />
              </div>

              <div>
                <h2 style={{ margin: 0 }}>{total_campaign}</h2>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  Total Campaigns
                </span>
              </div>
            </div>


          </Card>
        </Col>

        <Col xs={24} sm={12} md={12} lg={6}>
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
              display: "flex",
              alignItems: "center",
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",

            }}

          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#d1fae5",
                  padding: "10px",
                  borderRadius: "12px",
                  marginLeft: "-100px"

                }}
              >
                <EyeOutlined style={{ color: "#1fa7a1", fontSize: 18 }} />
              </div>

              <div>
                <h2 style={{ margin: 0 }}>{active_campaign}
                </h2>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  Active Campaigns
                </span>
              </div>
            </div>


          </Card>
        </Col>

        {/* Insider Risk */}
        <Col xs={24} sm={12} md={12} lg={6}>
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
              display: "flex",
              alignItems: "center",
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}

          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#f0914d68",
                  padding: "10px",
                  borderRadius: "12px",
                  marginLeft: "-120px"

                }}
              >
                <MailOutlined style={{ color: "#f97316", fontSize: 18 }} />
              </div>

              <div>
                <h2 style={{ margin: 0 }}>{total_sent}</h2>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  Total Sent
                </span>
              </div>
            </div>


          </Card>
        </Col>

        <Col xs={24} sm={12} md={12} lg={6}>
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
              display: "flex",
              alignItems: "center",
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}

          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#fee2e2",
                  padding: "10px",
                  borderRadius: "12px",
                  marginLeft: "-120px"
                }}
              >
                <TeamOutlined style={{ color: "red", fontSize: 18 }} />
              </div>

              <div>
                <h2 style={{ margin: 0 }}>{total_users}</h2>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  Total Users
                </span>
              </div>
            </div>


          </Card>
        </Col>
      </Row>


      <Card style={{ marginTop: "15px" }}>
        <Row gutter={16}>
          <Col span={20}>
            <Input
              addonBefore={<span>Name</span>}
              placeholder="Search by name"
              onChange={handleInput}
              size="large"
            />
          </Col>

        </Row>

        {loader ? (
          <CulsightPageLoader />
        ) : (
          <>
            {pagination_loader ? (
              <div style={{ textAlign: "center", padding: "60px" }}>
                <Spin indicator={<LoadingOutlined spin />} size="large" />
              </div>
            ) : (
              <Table
                columns={columns}
                pagination={false}
                dataSource={table_data}
                style={{ marginTop: "15px" }}
                rowKey="id"
              />
            )}

            {total_pages > 0 && (
              <div style={{ float: "right", marginTop: "20px" }}>
                <Pagination
                  current={current_page}
                  total={total_campaigns}
                  pageSize={page_size}
                  showSizeChanger
                  pageSizeOptions={['10', '20', '50', '100']}
                  onChange={pagination_on_change}
                  onShowSizeChange={(page, pageSize) => {
                    set_page_size(pageSize);
                    pagination_on_change(1, pageSize);
                  }}


                  style={{ display: "inline-block" }}
                  className="no-search-pagination"
                />

                <style>
                  {`
    .no-search-pagination .ant-select-selection-search-input {
      display: none !important;
    }
  `}
                </style>

              </div>
            )}
          </>
        )}
      </Card>
    </div>

  );
}

export default Campaign;
